var map = {
	"./title-about.de-CH.json": 1521,
	"./title-about.de-DE.json": 1522,
	"./title-about.en-CA.json": 1523,
	"./title-about.en-GB.json": 1524,
	"./title-about.en-IN.json": 1525,
	"./title-about.en-ME.json": 1526,
	"./title-about.en-US.json": 1527,
	"./title-about.es-EM.json": 1528,
	"./title-about.es-ES.json": 1529,
	"./title-about.fr-BE.json": 1530,
	"./title-about.fr-CA.json": 1531,
	"./title-about.fr-CH.json": 1532,
	"./title-about.nl-BE.json": 1533,
	"./title-about.nl-NL.json": 1534,
	"./title-about.pl-PL.json": 1535,
	"./title-about.pt-BR.json": 1536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1520;